import { api } from "../../api";
//deploy
export default (build) =>
  build.mutation({
    query: ({ uid, confirmDeletion = false }) => {
      return {
        url: `/superadmin/delete/${uid}`,
        method: "DELETE",
        body: {
          confirmDeletion,
        },
      };
    },
    invalidatesTags: (result, error, { uid }) => [
      { type: "Users", id: "LIST" },
      { type: "User", id: uid },
    ],
    async onQueryStarted({ uid, queryArgs }, { dispatch, queryFulfilled }) {
      const patchUsers = dispatch(
        api.util.updateQueryData("getUsers", queryArgs, (draft) => {
          draft.users = draft.users.filter((user) => user.uid !== uid);
        }),
      );

      try {
        await queryFulfilled;
      } catch (error) {
        patchUsers.undo();
      }
    },
  });
